import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home'
import About from './views/About'
import Manage from './views/Property/Manage'
import PropertyList from './views/Property/PropertyList'
import Property from './views/Property/Property'
import ExpenseList from './views/Property/ExpenseList'
import InventoryList from './views/Property/InventoryList'
import RentalCalcList from './views/Calculators/RentalCalcList'
import RentalCalc from './views/Calculators/RentalCalc'
import MortgageCalc from './views/Calculators/MortgageCalc'
import HelloWorld from './components/HelloWorld'
import Signin from './views/Signin'
import Signup from './views/Signup'
import SignUpRequired from './views/SignUpRequired'
import store from './store.js'

Vue.use(Router)

const routes = [
    { path: '/', component: Home, name: "def" },
    { path: '/signin', component: Signin, name: "signin"},
    { path: '/signup', component: Signup, name: "signup"},
    { path: '/manage', component: Manage, name: "manage" },
    { path: '/mortgageCalc', component: MortgageCalc, name: "mortgageCalc" },
    { path: '/about', component: About, name: "about" },
    { path: '/helloWorld', component: HelloWorld, name: 'helloWorld'},
    { path: '/signupRequired', component: SignUpRequired, name: 'signupRequired' },
    { path: '/rentalCalcList', 
        component:RentalCalcList, 
        name:"rentalCalcList", 
        beforeEnter(to, from, next) 
        {
          if (!store.getters.isAuthenticated) {
            next('/signuprequired');
          }
          else {
            next();
          }
        } 
    },
    { path: '/rentalCalc', 
      component: RentalCalc, 
      name: "rentalCalc", 
      beforeEnter(to, from, next) 
      {
        if (!store.getters.isAuthenticated) {
          next('/signuprequired');
        }
        else {
          next();
        } 
      }
    },
    { path: '/property/propertyList', component: PropertyList, name: "propertyList", beforeEnter(to, from, next) { if (!store.getters.isAuthenticated) { next('/signuprequired'); } else { next(); } } },
    { path: '/property/:id', component: Property, name: "property", beforeEnter(to, from, next) { if (!store.getters.isAuthenticated) { next('/signuprequired'); } else { next(); } } },
    { path: '/expenses/:id', component: ExpenseList, name: "expenseList", beforeEnter(to, from, next) { if (!store.getters.isAuthenticated) { next('/signuprequired'); } else { next(); } } },
    { path: '/invetntory/:id', component: InventoryList, name: "inventoryList", beforeEnter(to, from, next) { if (!store.getters.isAuthenticated) { next('/signuprequired'); } else { next(); } } }
  ]
  
 export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes //short for 'routes: routes'
  })